import React from 'react';

import { AccordionItem } from './components/AccordionItem';

import { useParseHub2Components } from '@interlayer/js/app/hooks/useParseHub2Components';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TAccordionProps } from './types';

import style from './Accordion.scss';

export const Accordion: React.FC<TAccordionProps> = ({ config, children, className = '' }) => {
    const parseHub2Components = useParseHub2Components();

    if (!config) {
        return (
            <div className={clsx(style.accordion, className)}>
                {children}
            </div>
        );
    }

    const {
        accordion = {},
        descriptionBeforeAccordion,
        descriptionAfterAccordion,
        title: componentTitle,
        isTitleCentered
    } = config;

    if (!accordion.accordionItems?.length) {
        return null;
    }

    return (
        <div className={style.wrap}>
            <div className={style.container}>
                {componentTitle && (
                    <div
                        className={clsx(style.componentTitle, { [style.isTitleCentered]: isTitleCentered })}
                    >
                        {componentTitle}
                    </div>
                )}

                {descriptionBeforeAccordion && (
                    <div className={style.description}>
                        {parseHub2Components(descriptionBeforeAccordion)}
                    </div>
                )}

                <div className={clsx(style.accordion, className)}>
                    {accordion.accordionItems.map(({ title, description, isOpen, anchor }, index) => (
                        <AccordionItem id={anchor} key={index} title={title} opened={isOpen}>
                            {parseHub2Components(description)}
                        </AccordionItem>
                    ))}
                </div>

                {descriptionAfterAccordion && (
                    <div className={style.description}>
                        {parseHub2Components(descriptionAfterAccordion)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Accordion;
